module.exports = __webpack_public_path__ + "static/media/工程咨询甲级资信-全专业规划和评估咨询@3x.a1fde5ff.png";